'use strict';
import angular from 'angular';

angular.module('reporting.services', [])
    .service('ReportService', ReportService)
    .service('ReportFactory', ReportFactory);

ReportService.$inject = ['ReportFactory', '$q'];
function ReportService(ReportFactory, $q) {
    var service = {};
    service.orders = null;
    service.columns = null;
    service.filters = null;
    service.templates = null;
    service.template = null;
    service.taskColumns = null;
    service.taskFilters = null;
    service.tasks = null;
    service.lineItemColumns = null;
    service.lineItemFilters = null;
    service.lineItems = null;
    service.masterColumns = null;
    service.masterFilters = null;
    service.masterRows = null;
    service.slotBookingColumns = null;
    service.slotBookingFilters = null;
    service.slotBookings = null;
    service.orderHistoryColumns = null;
    service.orderHistoryFilters = null;
    service.orderHistoryRows = null;
    service.lineItemHistoryColumns = null;
    service.lineItemHistoryFilters = null;
    service.lineItemHistoryRows = null;


    service.getOrders = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds[]'] = clusterIds;
        }

        ReportFactory.orders().get(params).$promise.then(function(data) {
            service.orders = data.orders;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderColumns = function() {
        var deferred = $q.defer();

        ReportFactory.orderColumns().get().$promise.then(function(data) {
            service.columns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.orderFilters().save(params).$promise.then(function(data) {
            service.filters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getPopulatedReportTemplates = function(typeId, clusterIds) {
        var deferred = $q.defer();
        var params = {
            'typeId': typeId,
            'clusterIds': clusterIds
        };

        ReportFactory.populatedReportTemplates().save(params).$promise.then(function(data) {
            service.templates = data.reportTemplates;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addReportTemplate = function(template) {
        var deferred = $q.defer();

        ReportFactory.reportTemplate().save(template).$promise.then(function(data) {
            service.template = data.reportTemplate;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateReportTemplate = function(template) {
        var deferred = $q.defer();

        ReportFactory.reportTemplate().update(template).$promise.then(function(data) {
            service.template = data.reportTemplate;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTasks = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds[]'] = clusterIds;
        }

        ReportFactory.tasks().get(params).$promise.then(function(data) {
            service.tasks = data.taskAssignments;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTaskColumns = function() {
        var deferred = $q.defer();

        ReportFactory.taskColumns().get().$promise.then(function(data) {
            service.taskColumns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTaskFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.taskFilters().save(params).$promise.then(function(data) {
            service.taskFilters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItems = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds[]'] = clusterIds;
        }

        ReportFactory.lineItems().get(params).$promise.then(function(data) {
            service.lineItems = data.lineItems;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItemColumns = function() {
        var deferred = $q.defer();

        ReportFactory.lineItemColumns().get().$promise.then(function(data) {
            service.lineItemColumns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItemFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.lineItemFilters().save(params).$promise.then(function(data) {
            service.lineItemFilters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getMasterRows = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds[]'] = clusterIds;
        }

        ReportFactory.masterRows().get(params).$promise.then(function(data) {
            service.masterRows = data.rows;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getMasterColumns = function() {
        var deferred = $q.defer();

        ReportFactory.masterColumns().get().$promise.then(function(data) {
            service.masterColumns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getMasterFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};
        ReportFactory.masterFilters().save(params).$promise.then(function(data) {
            service.masterFilters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSlotBookings = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds[]'] = clusterIds;
        }

        ReportFactory.slotBookings().get(params).$promise.then(function(data) {
            service.slotBookings = data.slotBookings;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSlotBookingColumns = function() {
        var deferred = $q.defer();

        ReportFactory.slotBookingColumns().get().$promise.then(function(data) {
            service.columns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSlotBookingFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.slotBookingFilters().save(params).$promise.then(function(data) {
            service.filters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderHistoryRows = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds'] = clusterIds;
        }

        ReportFactory.orderHistoryRows().save(params).$promise.then(function(data) {
            service.orderHistoryRows = data.rows;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderHistoryColumns = function() {
        var deferred = $q.defer();

        ReportFactory.orderHistoryColumns().get().$promise.then(function(data) {
            service.orderHistoryColumns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderHistoryFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.orderHistoryFilters().save(params).$promise.then(function(data) {
            service.orderHistoryFilters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };



    service.getLineItemHistoryRows = function(filters, clusterIds) {
        var deferred = $q.defer();
        var params = filters;

        if(clusterIds || clusterIds === 0){
            params['clusterIds'] = clusterIds;
        }

        ReportFactory.lineItemHistoryRows().save(params).$promise.then(function(data) {
            service.lineItemHistoryRows = data.rows;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItemHistoryColumns = function() {
        var deferred = $q.defer();

        ReportFactory.lineItemHistoryColumns().get().$promise.then(function(data) {
            service.lineItemHistoryColumns = data.columns;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItemHistoryFilters = function(clusterIds) {
        var deferred = $q.defer();
        var params = {'clusterIds': clusterIds};

        ReportFactory.lineItemHistoryFilters().save(params).$promise.then(function(data) {
            service.lineItemHistoryFilters = data.filters;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    return service;



}

ReportFactory.$inject = ['$resource', 'AppConfig'];
function ReportFactory($resource, AppConfig) {

    var factory = {};

    factory.orders = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orders', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.orderColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orderColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.orderFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orderFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.populatedReportTemplates = function() {
        return $resource(AppConfig.IO_API_URL + 'reportTemplates/populatedTemplates', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.reportTemplate = function() {
        return $resource(AppConfig.IO_API_URL + 'reportTemplates/template', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method: 'PUT',
                isArray: false
            }
        });
    };

    factory.tasks = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/taskAssignments', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/taskAssignmentColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.taskFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/taskAssignmentFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.lineItems = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItems', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.lineItemColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItemColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.lineItemFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItemFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.masterRows = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/master', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.masterColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/masterColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.masterFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/masterFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.orderHistoryRows = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orderHistory', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.orderHistoryColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orderHistoryColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.orderHistoryFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/orderHistoryFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.lineItemHistoryRows = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItemHistory', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.lineItemHistoryColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItemHistoryColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.lineItemHistoryFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/lineItemHistoryFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.slotBookings = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/slotBookings', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.slotBookingColumns = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/slotBookingColumns', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.slotBookingFilters = function() {
        return $resource(AppConfig.IO_API_URL + 'reports/slotBookingFilters', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    return factory;
}